<template>
    <div v-if="loading" role="status" aria-label="Page loading" class="fullpage-loading-overlay">
        <LoadingSpinner class="h-16 text-[#722ED1]" />
    </div>
</template>

<script setup>
import LoadingSpinner from "~vue/icons/LoadingSpinner.vue";
import { ref } from "vue";
</script>

<script>
const loading = ref(false);
export function showFullPageLoading() {
    loading.value = true;
}
export function hideFullPageLoading() {
    loading.value = false;
}
</script>

<style scoped>
.fullpage-loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 9999;
    background: rgba(255, 255, 255, 0.6);
    backdrop-filter: blur(8px);
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
